export default {
  threshold: 0.0,
  ignoreLocation: true,
};
